/* eslint-disable import/prefer-default-export */
const config = {
  initialColorMode: 'whiteAlpha',
  useSystemColorMode: true,
};
export default config;
